export function arrayWithUniqueIds(array) {
  return array.filter((e, i) => array.findIndex((a) => a.id === e.id) === i);
}

export function combineArrays(...arrays) {
  return [].concat(...arrays.filter(Array.isArray));
}
